export default __webpack_public_path__ + "static/media/logo-manole-play-white.9455125d.svg";